"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatDayPickerDays;
var _dayjs = _interopRequireDefault(require("dayjs"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _includes = _interopRequireDefault(require("lodash/includes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function formatDayPickerDays(dates) {
  var daysToShowPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
  var maxPagesToShow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var dateRange = getDateRange(dates[0], dates[dates.length - 1], daysToShowPerPage);
  var datesAsString = dates.join(',');
  var newDates = dateRange.map(function (date, index) {
    return {
      labelDay: (0, _dayjs["default"])(date).format('D'),
      labelMonth: (0, _dayjs["default"])(date).format('MMM'),
      active: isDateActive(datesAsString, date),
      date: getOriginalDateValue(dates, date)
    };
  });
  var dateRangeByPage = convertDatesIntoArraysOfDates(newDates, daysToShowPerPage, maxPagesToShow);
  return dateRangeByPage;
}
function isDateActive(dates, date) {
  return dates.indexOf((0, _dayjs["default"])(date).format('YYYY-MM-DD')) > -1;
}
function getOriginalDateValue(dates, date) {
  return dates[(0, _findIndex["default"])(dates, function (d) {
    return d && (0, _includes["default"])(d, (0, _dayjs["default"])(date.toISOString()).format('YYYY-MM-DD'));
  })];
}
function convertDatesIntoArraysOfDates(myArray, daysToShowPerPage, maxPagesToShow) {
  var results = [];
  while (myArray.length && results.length !== maxPagesToShow) {
    results.push(myArray.splice(0, daysToShowPerPage));
  }
  return results;
}
function getDateRange(firstDate, lastDate, daysToShowPerPage) {
  var dateArray = [];
  var startDate = (0, _dayjs["default"])(firstDate).startOf('week');
  var stopDate = (0, _dayjs["default"])(lastDate).endOf('week');
  while (startDate.isBefore(stopDate)) {
    dateArray.push(startDate);
    startDate = (0, _dayjs["default"])(startDate).add(1, 'day');
  }
  var needToPadDateArrayWithUnavailableDays = dateArray.length % daysToShowPerPage !== 0;
  if (needToPadDateArrayWithUnavailableDays) {
    var newStartDate = (0, _dayjs["default"])(dateArray[dateArray.length - 1]).add(1, 'day');
    var newStopDate = stopDate.add(7, 'day');
    while (newStartDate <= newStopDate) {
      dateArray.push(newStartDate);
      newStartDate = (0, _dayjs["default"])(newStartDate).add(1, 'day');
    }
  }
  return dateArray;
}